import React, { Fragment, useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getProfileById } from "../../actions/profile";
import {
  getModerators,
  promoteModerator,
  demoteModerator,
  deleteModerator,
  getTimedOutUsers,
  getBannedUsers,
  unTimeoutUser,
  unBanUser,
  getSupporters,
  addSupporter,
  deleteSupporter,
} from "../../actions/stream";
import { getReports, deleteReport } from "../../actions/report";
import { deleteUser, getActiveUsers } from "../../actions/auth";

import LoggedInNavRed from "../layout/IME/LoggedInNavRed";
import LoggedInNavBlue from "../layout/IME/LoggedInNavBlue";
import RegisterUser from "../layout/Innovators/RegisterUser";
import TimeOutUser from "../layout/IME/TimeOutUser";
import ReportedUserItem from "../layout/IME/ReportedUserItem";
import ModeratorItem from "../layout/IME/ModeratorItem";
import RecentSupporterItem from "../layout/Campaign/RecentSupporterItem";
import UserItem from "../layout/Campaign/UserItem";
import BannedUserItem from "../layout/IME/BannedUserItem";

const Dashboard = ({
  match,
  auth: { user, message },
  message: { users },
  profile: { profile },
  stream: { moderators, timed_out_users, supporters, banned_users },
  report: { reportedUsers },
  isAuthenticated,
  getActiveUsers,
  getProfileById,
  getModerators,
  promoteModerator,
  demoteModerator,
  deleteModerator,
  getTimedOutUsers,
  getBannedUsers,
  unTimeoutUser,
  unBanUser,
  getReports,
  deleteReport,
  getSupporters,
  addSupporter,
  deleteSupporter,
  deleteUser,
}) => {
  const [showDetails, setShowDetails] = useState(false);
  const [textValue, setTextValue] = useState("");
  const [showView, setShowView] = useState({
    dashboard: true,
    moderators: false,
    timedOut: false,
    reports: false,
    banned: false,
    supporters: false,
    users: false,
  });
  const [supporter, setSupporter] = useState({
    channelid: "",
    amount: 0,
  });

  useEffect(() => {
    getProfileById(match.params.channelid);
    getModerators(match.params.channelid);
    getTimedOutUsers(match.params.channelid);
    getBannedUsers(match.params.channelid);
    getReports();
    getSupporters();
  }, [
    getProfileById,
    getTimedOutUsers,
    getBannedUsers,
    getReports,
    getSupporters,
  ]);

  useEffect(() => {
    getActiveUsers(textValue);
  }, [textValue]);

  if (!isAuthenticated) {
    return <Redirect to="/" />;
  } else if (isAuthenticated && user && user.channelid !== "roland") {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      {profile && profile.role === "mentor" && profile.id === user.id && (
        <div>
          <LoggedInNavRed />
          <div className="flex-all-content-fixed">
            {showView.dashboard && (
              <div className="dashboard-container">
                <div className="dash-greet red">
                  Good Day, {user && user.firstname}
                  <i className="far fa-laugh-beam fa-lg red mx-10"></i>
                </div>
                <div className="dash-note white">
                  Please see information about your account below
                </div>
                <div className="flex-only-dash">
                  <p
                    onClick={() =>
                      setShowView({
                        dashboard: false,
                        moderators: true,
                        timedOut: false,
                        reports: false,
                        banned: false,
                        supporters: false,
                        users: false,
                      })
                    }
                    className="supporters red bold"
                  >
                    Moderators
                  </p>
                  <p
                    onClick={() =>
                      setShowView({
                        dashboard: false,
                        moderators: false,
                        timedOut: true,
                        reports: false,
                        banned: false,
                        supporters: false,
                        users: false,
                      })
                    }
                    className="supporters red bold"
                  >
                    Timed Out Users
                  </p>
                  <p
                    onClick={() =>
                      setShowView({
                        dashboard: false,
                        moderators: false,
                        timedOut: false,
                        reports: true,
                        banned: false,
                        supporters: false,
                        users: false,
                      })
                    }
                    className="supporters red bold"
                  >
                    Reports
                  </p>
                  <p
                    onClick={() =>
                      setShowView({
                        dashboard: false,
                        moderators: false,
                        timedOut: false,
                        reports: false,
                        banned: true,
                        supporters: false,
                        users: false,
                      })
                    }
                    className="supporters red bold"
                  >
                    Banned Users
                  </p>
                  <p
                    onClick={() =>
                      setShowView({
                        dashboard: false,
                        moderators: false,
                        timedOut: false,
                        reports: false,
                        banned: false,
                        supporters: true,
                        users: false,
                      })
                    }
                    className="supporters red bold"
                  >
                    Recent Supporters
                  </p>
                  <p
                    onClick={() =>
                      setShowView({
                        dashboard: false,
                        moderators: false,
                        timedOut: false,
                        reports: false,
                        banned: false,
                        supporters: false,
                        users: true,
                      })
                    }
                    className="supporters red bold"
                  >
                    Add Users
                  </p>
                </div>
                <div className="dash-sub-container">
                  <div className="dash-date red">
                    <i className="far fa-arrow-alt-circle-left fa-lg red mx-5 mt-4"></i>
                    <span className="large-font-alt white mx-10">
                      January 2020
                    </span>{" "}
                    -
                    <span className="large-font-alt white mx-10">
                      February 2020
                    </span>
                    <i className="far fa-arrow-alt-circle-right fa-lg red mx-5"></i>
                  </div>
                  <div className="dash-stats">
                    <div className="dash-stat red">
                      <div className="padd">
                        <i className="fas fa-dollar-sign fa-lg red mr-5"></i>
                        <span className="stat-number white">9,742,000.00</span>
                      </div>
                      <div className="stat-name">Revenue</div>
                    </div>
                    <div className="dash-stat red">
                      <div className="padd">
                        <i className="fas fa-angle-up fa-2x red mr-5"></i>
                        <span className="stat-number white mx-5">90</span>
                      </div>
                      <div className="stat-name">Subscribers</div>
                    </div>
                    <div className="dash-stat red">
                      <div className="padd">
                        <i className="fas fa-angle-up fa-2x red mr-5"></i>
                        <span className="stat-number white mx-5">90</span>
                      </div>
                      <div className="stat-name">Followers</div>
                    </div>
                    <div className="dash-stat red">
                      <div className="padd">
                        <span className="stat-number white mx-5">90.4k</span>
                      </div>
                      <div className="stat-name">Views</div>
                    </div>
                  </div>
                </div>
                <div className="dashboard-center-container">
                  <div className="input-label-container-dashboard">
                    <label
                      htmlFor="streamkey"
                      className="container-label bold red"
                    >
                      Stream Key:
                    </label>
                    <div className="container-hidden-input-dashboard">
                      <input
                        className="round-input-alt"
                        type="password"
                        name="streamkey"
                        value="123456789123456789123456789123456789123456789"
                      />
                      <button className="round-button-stream background-red">
                        <i className="far fa-copy"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {showView.moderators && (
              <div className="dashboard-container">
                <div className="dash-greet red">
                  Good Day, {user && user.firstname}
                  <i className="far fa-laugh-beam fa-lg red mx-10"></i>
                </div>
                <div className="dash-note white">
                  Please see information about your account below
                </div>
                <div className="flex-only-dash">
                  <p
                    onClick={() =>
                      setShowView({
                        dashboard: true,
                        moderators: false,
                        timedOut: false,
                        reports: false,
                        banned: false,
                        supporters: false,
                        users: false,
                      })
                    }
                    className="supporters red bold"
                  >
                    Dashboard
                  </p>
                  <p
                    onClick={() =>
                      setShowView({
                        dashboard: false,
                        moderators: false,
                        timedOut: true,
                        reports: false,
                        banned: false,
                        supporters: false,
                        users: false,
                      })
                    }
                    className="supporters red bold"
                  >
                    Timed Out Users
                  </p>
                  <p
                    onClick={() =>
                      setShowView({
                        dashboard: false,
                        moderators: false,
                        timedOut: false,
                        reports: true,
                        banned: false,
                        supporters: false,
                        users: false,
                      })
                    }
                    className="supporters red bold"
                  >
                    Reports
                  </p>
                  <p
                    onClick={() =>
                      setShowView({
                        dashboard: false,
                        moderators: false,
                        timedOut: false,
                        reports: false,
                        banned: true,
                        supporters: false,
                        users: false,
                      })
                    }
                    className="supporters red bold"
                  >
                    Banned Users
                  </p>
                  <p
                    onClick={() =>
                      setShowView({
                        dashboard: false,
                        moderators: false,
                        timedOut: false,
                        reports: false,
                        banned: false,
                        supporters: true,
                        users: false,
                      })
                    }
                    className="supporters red bold"
                  >
                    Recent Supporters
                  </p>
                  <p
                    onClick={() =>
                      setShowView({
                        dashboard: false,
                        moderators: false,
                        timedOut: false,
                        reports: false,
                        banned: false,
                        supporters: false,
                        users: true,
                      })
                    }
                    className="supporters red bold"
                  >
                    Add Users
                  </p>
                </div>
                <div className="report-dashboard">
                  <label
                    htmlFor="streamkey"
                    className="container-label bold red"
                  >
                    Moderators:
                  </label>
                  <div className="report-items">
                    {moderators && moderators.length > 0 ? (
                      moderators.map((moderator) => {
                        return (
                          <ModeratorItem
                            key={moderator.channelid}
                            moderator={moderator}
                            promoteModerator={promoteModerator}
                            demoteModerator={demoteModerator}
                            deleteModerator={deleteModerator}
                          />
                        );
                      })
                    ) : (
                      <div
                        className={`empty-content-posts ${
                          profile && profile.role === "innovator"
                            ? "green"
                            : profile && profile.role === "mentor"
                            ? "red"
                            : "blue"
                        }`}
                      >
                        No Moderators
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
            {showView.timedOut && (
              <div className="dashboard-container">
                <div className="dash-greet red">
                  Good Day, {user && user.firstname}
                  <i className="far fa-laugh-beam fa-lg red mx-10"></i>
                </div>
                <div className="dash-note white">
                  Please see information about your account below
                </div>
                <div className="flex-only-dash">
                  <p
                    onClick={() =>
                      setShowView({
                        dashboard: true,
                        moderators: false,
                        timedOut: false,
                        reports: false,
                        banned: false,
                        supporters: false,
                        users: false,
                      })
                    }
                    className="supporters red bold"
                  >
                    Dashboard
                  </p>
                  <p
                    onClick={() =>
                      setShowView({
                        dashboard: false,
                        moderators: true,
                        timedOut: false,
                        reports: false,
                        banned: false,
                        supporters: false,
                        users: false,
                      })
                    }
                    className="supporters red bold"
                  >
                    Moderators
                  </p>
                  <p
                    onClick={() =>
                      setShowView({
                        dashboard: false,
                        moderators: false,
                        timedOut: false,
                        reports: true,
                        banned: false,
                        supporters: false,
                        users: false,
                      })
                    }
                    className="supporters red bold"
                  >
                    Reports
                  </p>
                  <p
                    onClick={() =>
                      setShowView({
                        dashboard: false,
                        moderators: false,
                        timedOut: false,
                        reports: false,
                        banned: true,
                        supporters: false,
                        users: false,
                      })
                    }
                    className="supporters red bold"
                  >
                    Banned Users
                  </p>
                  <p
                    onClick={() =>
                      setShowView({
                        dashboard: false,
                        moderators: false,
                        timedOut: false,
                        reports: false,
                        banned: false,
                        supporters: true,
                        users: false,
                      })
                    }
                    className="supporters red bold"
                  >
                    Recent Supporters
                  </p>
                  <p
                    onClick={() =>
                      setShowView({
                        dashboard: false,
                        moderators: false,
                        timedOut: false,
                        reports: false,
                        banned: false,
                        supporters: false,
                        users: true,
                      })
                    }
                    className="supporters red bold"
                  >
                    Add Users
                  </p>
                </div>
                <div className="report-dashboard">
                  <label
                    htmlFor="streamkey"
                    className="container-label bold red"
                  >
                    Timed Out Users:
                  </label>
                  <div className="report-items">
                    {timed_out_users && timed_out_users.length > 0 ? (
                      timed_out_users.map((timed_out_user) => {
                        return (
                          <TimeOutUser
                            key={timed_out_user.channelid}
                            timed_out_user={timed_out_user}
                            unTimeoutUser={unTimeoutUser}
                          />
                        );
                      })
                    ) : (
                      <div
                        className={`empty-content-posts ${
                          profile && profile.role === "innovator"
                            ? "green"
                            : profile && profile.role === "mentor"
                            ? "red"
                            : "blue"
                        }`}
                      >
                        No Timed Out Users
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
            {showView.reports && (
              <div className="dashboard-container">
                <div className="dash-greet red">
                  Good Day, {user && user.firstname}
                  <i className="far fa-laugh-beam fa-lg red mx-10"></i>
                </div>
                <div className="dash-note white">
                  Please see information about your account below
                </div>
                <div className="flex-only-dash">
                  <p
                    onClick={() =>
                      setShowView({
                        dashboard: true,
                        moderators: false,
                        timedOut: false,
                        reports: false,
                        banned: false,
                        supporters: false,
                        users: false,
                      })
                    }
                    className="supporters red bold"
                  >
                    Dashboard
                  </p>
                  <p
                    onClick={() =>
                      setShowView({
                        dashboard: false,
                        moderators: true,
                        timedOut: false,
                        reports: false,
                        banned: false,
                        supporters: false,
                        users: false,
                      })
                    }
                    className="supporters red bold"
                  >
                    Moderators
                  </p>
                  <p
                    onClick={() =>
                      setShowView({
                        dashboard: false,
                        moderators: false,
                        timedOut: true,
                        reports: false,
                        banned: false,
                        supporters: false,
                        users: false,
                      })
                    }
                    className="supporters red bold"
                  >
                    Timed Out Users
                  </p>
                  <p
                    onClick={() =>
                      setShowView({
                        dashboard: false,
                        moderators: false,
                        timedOut: false,
                        reports: false,
                        banned: true,
                        supporters: false,
                        users: false,
                      })
                    }
                    className="supporters red bold"
                  >
                    Banned Users
                  </p>
                  <p
                    onClick={() =>
                      setShowView({
                        dashboard: false,
                        moderators: false,
                        timedOut: false,
                        reports: false,
                        banned: false,
                        supporters: true,
                        users: false,
                      })
                    }
                    className="supporters red bold"
                  >
                    Recent Supporters
                  </p>
                  <p
                    onClick={() =>
                      setShowView({
                        dashboard: false,
                        moderators: false,
                        timedOut: false,
                        reports: false,
                        banned: false,
                        supporters: false,
                        users: true,
                      })
                    }
                    className="supporters red bold"
                  >
                    Add Users
                  </p>
                </div>
                <div className="report-dashboard">
                  <label
                    htmlFor="streamkey"
                    className="container-label bold red"
                  >
                    Reports:
                  </label>
                  <div className="report-items">
                    {reportedUsers && reportedUsers.length > 0 ? (
                      reportedUsers.map((user) => {
                        return (
                          <ReportedUserItem
                            key={user.channelid}
                            user={user}
                            setShowDetails={setShowDetails}
                            showDetails={showDetails}
                            deleteReport={deleteReport}
                          />
                        );
                      })
                    ) : (
                      <div
                        className={`empty-content-posts ${
                          profile && profile.role === "innovator"
                            ? "green"
                            : profile && profile.role === "mentor"
                            ? "red"
                            : "blue"
                        }`}
                      >
                        No Reported Users
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
            {showView.banned && (
              <div className="dashboard-container">
                <div className="dash-greet red">
                  Good Day, {user && user.firstname}
                  <i className="far fa-laugh-beam fa-lg red mx-10"></i>
                </div>
                <div className="dash-note white">
                  Please see information about your account below
                </div>
                <div className="flex-only-dash">
                  <p
                    onClick={() =>
                      setShowView({
                        dashboard: true,
                        moderators: false,
                        timedOut: false,
                        reports: false,
                        banned: false,
                        supporters: false,
                        users: false,
                      })
                    }
                    className="supporters red bold"
                  >
                    Dashboard
                  </p>
                  <p
                    onClick={() =>
                      setShowView({
                        dashboard: false,
                        moderators: true,
                        timedOut: false,
                        reports: false,
                        banned: false,
                        supporters: false,
                        users: false,
                      })
                    }
                    className="supporters red bold"
                  >
                    Moderators
                  </p>
                  <p
                    onClick={() =>
                      setShowView({
                        dashboard: false,
                        moderators: false,
                        timedOut: true,
                        reports: false,
                        banned: false,
                        supporters: false,
                        users: false,
                      })
                    }
                    className="supporters red bold"
                  >
                    Timed Out Users
                  </p>
                  <p
                    onClick={() =>
                      setShowView({
                        dashboard: false,
                        moderators: false,
                        timedOut: false,
                        reports: true,
                        banned: false,
                        supporters: false,
                        users: false,
                      })
                    }
                    className="supporters red bold"
                  >
                    Reports
                  </p>
                  <p
                    onClick={() =>
                      setShowView({
                        dashboard: false,
                        moderators: false,
                        timedOut: false,
                        reports: false,
                        banned: false,
                        supporters: true,
                        users: false,
                      })
                    }
                    className="supporters red bold"
                  >
                    Recent Supporters
                  </p>
                  <p
                    onClick={() =>
                      setShowView({
                        dashboard: false,
                        moderators: false,
                        timedOut: false,
                        reports: false,
                        banned: false,
                        supporters: false,
                        users: true,
                      })
                    }
                    className="supporters red bold"
                  >
                    Add Users
                  </p>
                </div>
                <div className="report-dashboard">
                  <label
                    htmlFor="streamkey"
                    className="container-label bold red"
                  >
                    Banned Users:
                  </label>
                  <div className="report-items">
                    {banned_users && banned_users.length > 0 ? (
                      banned_users.map((banned_user) => {
                        return (
                          <BannedUserItem
                            key={banned_user.channelid}
                            banned_user={banned_user}
                            unBanUser={unBanUser}
                          />
                        );
                      })
                    ) : (
                      <div
                        className={`empty-content-posts ${
                          profile && profile.role === "innovator"
                            ? "green"
                            : profile && profile.role === "mentor"
                            ? "red"
                            : "blue"
                        }`}
                      >
                        No Banned Users
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
            {showView.supporters && (
              <div className="dashboard-container">
                <div className="dash-greet red">
                  Good Day, {user && user.firstname}
                  <i className="far fa-laugh-beam fa-lg red mx-10"></i>
                </div>
                <div className="dash-note white">
                  Please see information about your account below
                </div>
                <div className="flex-only-dash">
                  <p
                    onClick={() =>
                      setShowView({
                        dashboard: true,
                        moderators: false,
                        timedOut: false,
                        reports: false,
                        banned: false,
                        supporters: false,
                        users: false,
                      })
                    }
                    className="supporters red bold"
                  >
                    Dashboard
                  </p>
                  <p
                    onClick={() =>
                      setShowView({
                        dashboard: false,
                        moderators: true,
                        timedOut: false,
                        reports: false,
                        banned: false,
                        supporters: false,
                        users: false,
                      })
                    }
                    className="supporters red bold"
                  >
                    Moderators
                  </p>
                  <p
                    onClick={() =>
                      setShowView({
                        dashboard: false,
                        moderators: false,
                        timedOut: true,
                        reports: false,
                        banned: false,
                        supporters: false,
                        users: false,
                      })
                    }
                    className="supporters red bold"
                  >
                    Timed Out Users
                  </p>
                  <p
                    onClick={() =>
                      setShowView({
                        dashboard: false,
                        moderators: false,
                        timedOut: false,
                        reports: true,
                        banned: false,
                        supporters: false,
                        users: false,
                      })
                    }
                    className="supporters red bold"
                  >
                    Reports
                  </p>
                  <p
                    onClick={() =>
                      setShowView({
                        dashboard: false,
                        moderators: false,
                        timedOut: false,
                        reports: false,
                        banned: true,
                        supporters: false,
                        users: false,
                      })
                    }
                    className="supporters red bold"
                  >
                    Banned Users
                  </p>
                  <p
                    onClick={() =>
                      setShowView({
                        dashboard: false,
                        moderators: false,
                        timedOut: false,
                        reports: false,
                        banned: false,
                        supporters: false,
                        users: true,
                      })
                    }
                    className="supporters red bold"
                  >
                    Add Users
                  </p>
                </div>
                <div className="report-dashboard">
                  <label
                    htmlFor="streamkey"
                    className="container-label bold red"
                  >
                    Add Recent Supporter:
                  </label>
                  <div className="input-label-container">
                    <label htmlFor="lastname" className="labels-input bold red">
                      *Channel ID:
                    </label>
                    <input
                      type="text"
                      required
                      value={supporter.channelid}
                      className="input-item-dashboard"
                      placeholder="Enter Channel ID"
                      onChange={(e) => {
                        e.preventDefault();
                        setSupporter({
                          ...supporter,
                          channelid: e.target.value,
                        });
                      }}
                    />
                  </div>
                  <div className="input-label-container">
                    <label htmlFor="lastname" className="labels-input bold red">
                      *Amount:
                    </label>
                    <input
                      type="number"
                      required
                      value={supporter.amount}
                      className="input-item-dashboard"
                      placeholder="Enter Amount"
                      onChange={(e) => {
                        e.preventDefault();
                        setSupporter({ ...supporter, amount: e.target.value });
                      }}
                    />
                  </div>
                  {supporter.channelid !== "" && supporter.amount > 0 && (
                    <div className="submit-changes-register">
                      <button
                        onClick={() => {
                          addSupporter(supporter);
                          setSupporter({
                            channelid: "",
                            amount: 0,
                          });
                        }}
                        className="submit-changes-button background-red"
                      >
                        <i class="fa-solid fa-sack-dollar fa-lg mr-5"></i>Add
                        Supporter
                      </button>
                    </div>
                  )}
                  <div className="report-items">
                    {supporters && supporters.length > 0 ? (
                      supporters.map((supporter) => {
                        return (
                          <RecentSupporterItem
                            key={supporter.channelid}
                            supporter={supporter}
                            deleteSupporter={deleteSupporter}
                          />
                        );
                      })
                    ) : (
                      <div
                        className={`empty-content-posts ${
                          profile && profile.role === "innovator"
                            ? "green"
                            : profile && profile.role === "mentor"
                            ? "red"
                            : "blue"
                        }`}
                      >
                        No Supporters
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
            {showView.users && (
              <div className="dashboard-container">
                <div className="dash-greet red">
                  Good Day, {user && user.firstname}
                  <i className="far fa-laugh-beam fa-lg red mx-10"></i>
                </div>
                <div className="dash-note white">
                  Please see information about your account below
                </div>
                <div className="flex-only-dash">
                  <p
                    onClick={() =>
                      setShowView({
                        dashboard: true,
                        moderators: false,
                        timedOut: false,
                        reports: false,
                        banned: false,
                        supporters: false,
                        users: false,
                      })
                    }
                    className="supporters red bold"
                  >
                    Dashboard
                  </p>
                  <p
                    onClick={() =>
                      setShowView({
                        dashboard: false,
                        moderators: true,
                        timedOut: false,
                        reports: false,
                        banned: false,
                        supporters: false,
                        users: false,
                      })
                    }
                    className="supporters red bold"
                  >
                    Moderators
                  </p>
                  <p
                    onClick={() =>
                      setShowView({
                        dashboard: false,
                        moderators: false,
                        timedOut: true,
                        reports: false,
                        banned: false,
                        supporters: false,
                        users: false,
                      })
                    }
                    className="supporters red bold"
                  >
                    Timed Out Users
                  </p>
                  <p
                    onClick={() =>
                      setShowView({
                        dashboard: false,
                        moderators: false,
                        timedOut: false,
                        reports: true,
                        banned: false,
                        supporters: false,
                        users: false,
                      })
                    }
                    className="supporters red bold"
                  >
                    Reports
                  </p>
                  <p
                    onClick={() =>
                      setShowView({
                        dashboard: false,
                        moderators: false,
                        timedOut: false,
                        reports: false,
                        banned: true,
                        supporters: false,
                        users: false,
                      })
                    }
                    className="supporters red bold"
                  >
                    Banned Users
                  </p>
                  <p
                    onClick={() =>
                      setShowView({
                        dashboard: false,
                        moderators: false,
                        timedOut: false,
                        reports: false,
                        banned: false,
                        supporters: true,
                        users: false,
                      })
                    }
                    className="supporters red bold"
                  >
                    Recent Supporters
                  </p>
                </div>
                <div className="report-dashboard">
                  <RegisterUser
                    message={message}
                    getActiveUsers={getActiveUsers}
                    users={users}
                  />
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      if (textValue !== "") {
                        getActiveUsers(textValue);
                      }
                      setTextValue("");
                    }}
                  >
                    <div className="user-search-container">
                      <div className="article-search-container">
                        <form action="" className="trending-form-flex">
                          <div className="label-input">
                            <label htmlFor="" className="trending-labels red">
                              Search
                              <i className="fas fa-search red mx-5"></i>
                            </label>
                            <div className="input-drop-down">
                              <div className="search-input-hidden">
                                <input
                                  className="search-input-style"
                                  type="text"
                                  name="users"
                                  value={textValue}
                                  onChange={(e) => setTextValue(e.target.value)}
                                  placeholder="Enter User Name..."
                                />
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                    <div className="report-items">
                      {users && users.length > 0 ? (
                        users
                          .filter((user) => {
                            const regex = new RegExp(`^${textValue}`, "gi");
                            if (textValue !== "") {
                              return (
                                user.firstname.toLowerCase().match(regex) ||
                                user.lastname.toLowerCase().match(regex) ||
                                user.channelid.toLowerCase().match(regex)
                              );
                            }
                          })
                          .map((user) => {
                            return (
                              <UserItem
                                key={user.channelid}
                                user={user}
                                deleteUser={deleteUser}
                              />
                            );
                          })
                      ) : (
                        <div
                          className={`empty-content-posts ${
                            profile && profile.role === "innovator"
                              ? "green"
                              : profile && profile.role === "mentor"
                              ? "red"
                              : "blue"
                          }`}
                        >
                          No Users
                        </div>
                      )}
                    </div>
                  </form>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </Fragment>
  );
};

Dashboard.propTypes = {
  getProfileById: PropTypes.func.isRequired,
  getModerators: PropTypes.func.isRequired,
  promoteModerator: PropTypes.func.isRequired,
  demoteModerator: PropTypes.func.isRequired,
  deleteModerator: PropTypes.func.isRequired,
  getActiveUsers: PropTypes.func.isRequired,
  getTimedOutUsers: PropTypes.func.isRequired,
  getBannedUsers: PropTypes.func.isRequired,
  unTimeoutUser: PropTypes.func.isRequired,
  unBanUser: PropTypes.func.isRequired,
  getReports: PropTypes.func.isRequired,
  deleteReport: PropTypes.func.isRequired,
  getActiveUsers: PropTypes.func.isRequired,
  getSupporters: PropTypes.func.isRequired,
  addSupporter: PropTypes.func.isRequired,
  deleteSupporter: PropTypes.func.isRequired,
  deleteUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  stream: PropTypes.object.isRequired,
  reportedUsers: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  message: state.message,
  profile: state.profile,
  stream: state.stream,
  report: state.report,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, {
  getProfileById,
  getModerators,
  promoteModerator,
  demoteModerator,
  deleteModerator,
  getTimedOutUsers,
  getBannedUsers,
  unTimeoutUser,
  unBanUser,
  getReports,
  deleteReport,
  getSupporters,
  getActiveUsers,
  addSupporter,
  deleteSupporter,
  deleteUser,
  getActiveUsers,
})(Dashboard);
